import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import '@polymer/iron-icon/iron-icon.js';
import template from './sidebar-menu.html';
import '../forms/forms';

import { SocialNetworks } from '../forms/social-networks/social-networks';
import { FullProductCatalog } from '../forms/full-product-catalog/full-product-catalog';
import { PriceType } from '../forms/price-type/price-type';
import { LogoAndProfilePhoto } from '../forms/logo-and-profile-photo/logo-and-profile-photo';
import { AboutYourStore } from '../forms/about-your-store/about-your-store';
// import { FeaturedProducts } from '../forms/featured-products/featured-products';
import { ProductBundles } from '../forms/product-bundles/product-bundles';
import { EditStoreUrl } from '../forms/edit-store-url/edit-store-url';
// import { BannerContent } from '../forms/banner-content/banner-content';
import { ContactInformation } from '../forms/contact-information/contact-information';
import { MySiteApp, TOASTER_ACTIONS } from '../my-site-app';
import { MySiteRestService } from '@nuskin/my-site-api';
import { nuskin } from '@nuskin/ns-util';
import { UserService } from '@nuskin/ns-account';
import { MySiteAdminRedirection } from '../modals/mysite-admin-redirection';

/**
 * @customElement
 * @polymer
 */
export class SidebarMenu extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);
        // this.currentForm = SidebarMenu.is;
        this.storeURL = '';
        this.editStoreUrlAction = EditStoreUrl.is;

        this.forms = [
            // {action: BannerContent.is, title: this.content.bannerFormTitle},
            // {action: FeaturedProducts.is, title: this.content.featuredProductsFormTitle},
            {action: ProductBundles.is, title: this.content.bundlesFormTitle},
            {action: FullProductCatalog.is, title: this.content.fullProductCatalogFormTitle},
            {action: PriceType.is, title: this.content.priceTypeFormTitle},
            {action: AboutYourStore.is, title: this.content.aboutYourStoreFormTitle},
            {action: LogoAndProfilePhoto.is, title: this.content.logoAndProfilePhotoFormTitle},
            {action: ContactInformation.is, title: this.content.contactInformationFormTitle},
            {action: SocialNetworks.is, title: this.content.socialAccountsFormTitle}
        ];
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'sidebar-menu';
    }

    connectedCallback(){
        super.connectedCallback();
        this.mySite = document.querySelector(MySiteApp.is);
        this.mySite.addEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
        this.mySite.addEventListener('current-market-changed', this._subscribeToMarketChange.bind(this));
        this.mySite.addEventListener('current-language-changed', this._subscribeToLanguageChange.bind(this));
        this.$.marketSelect.addEventListener('selected-changed', this._handleMarketChange.bind(this));
    }

    disconnectedCallback(){
        super.disconnectedCallback();
        this.mySite.removeEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
        this.mySite.removeEventListener('current-market-changed', this._subscribeToMarketChange.bind(this));
        this.mySite.removeEventListener('current-language-changed', this._subscribeToLanguageChange.bind(this));
        this.$.marketSelect.removeEventListener('selected-changed', this._handleMarketChange.bind(this));
    }


    async _handleMarketChange(e) {
        this.mySite.currentMarket = e.detail.value;
        // Create instance of MySiteAdminRedirection and call checkMarketInContentstack
        const adminRedirection = new MySiteAdminRedirection();
        const nextgenMysite = await adminRedirection.checkMarketInContentstack(this.mySite.currentMarket);
        if (nextgenMysite && nextgenMysite.mysiteAdminRedirectionEnabled) {
            adminRedirection.handleRedirection(nextgenMysite, this.mySite.currentMarket, this.mySite.currentLanguage);
        }

        // GA
        try {
            nuskin.events.publish(nuskin.events.mySite.SITE_LOCALIZATION, {
                mySite: {
                    marketSwitchingTo: this.mySite.currentMarket
                }
            });
        } catch(err) {console.log(err)}
    }

    async _subscribeToMarketChange() {
        await this.setFullCatalogFormVisibility();
        await this.setPriceTypeFormVisibility();
        this.set('dynamicFormList', this.forms);
    }

    async setFullCatalogFormVisibility() {
        let mySiteConfig = await MySiteRestService.getMarketMySiteConfig(this.mySite.currentMarket, this.mySite.currentLanguage)
        let fullProductCatalogFormVisibility = mySiteConfig.fullProductCatalogFormVisibility === 'true';
        if(!fullProductCatalogFormVisibility) {
            this.forms = this.forms.filter(item => item.action !== FullProductCatalog.is);
        }
        this.mySite.fullProductCatalogFormVisibility = fullProductCatalogFormVisibility;
    }

    async setPriceTypeFormVisibility() {
        let mySiteConfig = await MySiteRestService.getMarketMySiteConfig(this.mySite.currentMarket, this.mySite.currentLanguage)
        if(mySiteConfig.allowPriceTypeWRTL !== 'true' || mySiteConfig.allowPriceTypeWWHL !== 'true')
            this.forms = this.forms.filter(item => item.action !== PriceType.is);
    }

    async _subscribeToLanguageChange(e) {
        this.set('currentLanguage', e.detail.value);
        await this.setFullCatalogFormVisibility();
        await this.setPriceTypeFormVisibility();
        this.set('dynamicFormList', this.forms);
    }

    async _subscribeToMySiteDataChanges(){
        this.set('data', this.mySite.mySiteData);
        this.set('storeURL', `https://mysite.${this.content.welcomePage1SiteDomain}/content/nuskin/${this.mySite.currentLanguage}_${this.mySite.currentMarket}/mysite/mysite-home.mysite.${Object.keys(this.data.storefront)[0]}.html?storeId=${UserService.getUser().id}`);
        this.set('storeURLClean', `https://${Object.keys(this.data.storefront)[0]}.${this.content.welcomePage1SiteDomain}`);
        this.set('marketsAndLanguages', Object.keys(this.mySite.marketsAndLanguages).map(code => {
            if(this.mySite.marketsAndLanguages[code].defaultLocale)
                return {
                    id: code,
                    text: this.mySite.marketsAndLanguages[code].displayName
                }
        }));
        this.set('currentMarket', this.mySite.currentMarket);
    }

    _onFocus(e) {
        e.currentTarget.$.input.select();
    }

    onMenuItemClick(e) {
        this.mySite.currentForm = e.currentTarget.dataset.action;

        // GA
        try {
            nuskin.events.publish(nuskin.events.mySite.EDIT_SECTION_CLICK, {
                mySite: {
                    section: this.mySite.currentForm,
                    action: 'sidebar'
                }
            });
        } catch(err) {console.log(err)}

        this.dispatchEvent(new CustomEvent('on-menu-item-click', {
            composed: true,
            bubbles: true,
            detail: {
                item: this.mySite.currentForm,
                additionalData: e.currentTarget.dataset.additionalData,
                mobile: this.mySite.isMobile
            }
        }));
    }

    _previewMySite(e) {
        let url = e.currentTarget.dataset.url;
        let win = window.open(url, '_blank');
        win.focus();
        // GA
        try {
            nuskin.events.publish(nuskin.events.mySite.URL_PREVIEW_SECTION, {
                mySite: {
                    action: 'preview button click'
                }
            });
        } catch(err) {console.log(err)}
    }

    _copyMySiteUrl() {
        let input = this.$.mySiteUrlField;

        let isiOSDevice = navigator.userAgent.match(/ipad|iphone/i);

        let editable = input.contentEditable;
        let readOnly = input.readOnly;

        if (isiOSDevice) {
            input.contentEditable = true;
            input.readOnly = false;

            let range = document.createRange();
            range.selectNodeContents(input);

            let selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            input.setSelectionRange(0, 999999);
        } else {
            input.select();
        }

        input.contentEditable = editable;
        input.readOnly = readOnly;

        document.execCommand('copy');

        // GA
        try {
            nuskin.events.publish(nuskin.events.mySite.URL_PREVIEW_SECTION, {
                mySite: {
                    action: 'copy url button click'
                }
            });
        } catch(err) {console.log(err)}

        this.mySite.dispatchEvent(new CustomEvent('my-site-toaster', {
            detail: {
                theme: 'success',
                icon: 'success',
                message: TOASTER_ACTIONS.copyUrl
            }
        }));
    }

    _preventDefault(e) {
        e.preventDefault();
        if(e.ctrlKey || e.metaKey)
        // GA
            try {
                nuskin.events.publish(nuskin.events.mySite.URL_PREVIEW_SECTION, {
                    mySite: {
                        action: 'clipboard copy'
                    }
                });
            } catch(err) {console.log(err)}
    }
}

window.customElements.define(SidebarMenu.is, SidebarMenu);